var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolanaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17313_49946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.59878 15.9222C7.69533 15.8221 7.8281 15.7637 7.96891 15.7637H20.7383C20.9717 15.7637 21.0883 16.0556 20.9234 16.2266L18.4009 18.8416C18.3043 18.9417 18.1716 19.0001 18.0308 19.0001H5.26134C5.028 19.0001 4.91133 18.7082 5.07627 18.5372L7.59878 15.9222Z",
    fill: "url(#paint0_linear_17313_49946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59878 6.15849C7.69936 6.05839 7.83212 6 7.96891 6H20.7383C20.9717 6 21.0883 6.29195 20.9234 6.46295L18.4009 9.07796C18.3043 9.17806 18.1716 9.23645 18.0308 9.23645H5.26134C5.028 9.23645 4.91133 8.9445 5.07627 8.7735L7.59878 6.15849Z",
    fill: "url(#paint1_linear_17313_49946)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4009 11.0091C18.3043 10.909 18.1716 10.8506 18.0308 10.8506H5.26134C5.028 10.8506 4.91133 11.1425 5.07627 11.3135L7.59878 13.9285C7.69533 14.0286 7.8281 14.087 7.96891 14.087H20.7383C20.9717 14.087 21.0883 13.7951 20.9234 13.6241L18.4009 11.0091Z",
    fill: "url(#paint2_linear_17313_49946)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17313_49946",
    x1: 19.5185,
    y1: 4.43797,
    x2: 10.1705,
    y2: 21.7097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17313_49946",
    x1: 15.6543,
    y1: 2.34643,
    x2: 6.30626,
    y2: 19.6182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17313_49946",
    x1: 17.5741,
    y1: 3.38558,
    x2: 8.22607,
    y2: 20.6573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17313_49946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13,
    fill: "white",
    transform: "translate(5 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIcon);
export default __webpack_public_path__ + "static/media/SolanaIcon.26696f76.svg";
export { ForwardRef as ReactComponent };